export function GetAnnouncementOfferStatusDescription(announcementStatusCode: string) {
    let announcementStatuses = new Map();
    announcementStatuses.set('REFUSED','Rifiutato');
    announcementStatuses.set('ACCEPTED','Accettato');
    announcementStatuses.set('SUBMITTED','Inviato');

    let stat = announcementStatuses.get(announcementStatusCode);
    return (stat === undefined || stat === null) ? announcementStatusCode : stat;
}